import Skeleton from 'react-loading-skeleton';

/**
 * Renders the placeholder card shown while an ongoing study loads. Lays out skeleton blocks matching the card header plus the study info, duration and strip preview areas.
 *
 * @returns The skeleton study card element.
 */
const StudyCardSkeleton = () => (
  <div className="study-card skeleton-study-card-container">
    <div className="header-container">
      <div className="header-container__left">
        <Skeleton height="100%" />
      </div>
    </div>
    <div className="body-container">
      <div className="body-container__left">
        <div className="study-info">
          <Skeleton height="100%" />
        </div>

        <div className="study-duration">
          <Skeleton height="100%" />
        </div>
      </div>
      <div className="body-container__right">
        <Skeleton height="100%" />
      </div>
    </div>
  </div>
);

export default StudyCardSkeleton;
